'use client';

import { useEffect } from 'react';

import type { AreaResponse } from '@/src/lib/api';
import { recordRecentArea } from '@/src/lib/hooks/area/useRecentAreas';

/** Adds the SRP's area to the location autocomplete's Recently Viewed list. */
export function RecentAreaRecorder({ area }: { area: AreaResponse }) {
  useEffect(() => {
    recordRecentArea(area);
  }, [area]);

  return null;
}
